import httpMultipart from "@/http-multipart";
import http from "@/http-common";

class FormSystemService {
    create(formData) {
        return httpMultipart.post(`/master/system-config/create-formSys`, formData);
    }

    update(formData) {
        return httpMultipart.put(`/master/system-config/update-formSys`, formData);
    }

    filterData(data) {
        return http.get(`/master/system-config/search-formSys`, {
            params: data
        })
    }

    getDataById(id) {
        return http.get(`/master/system-config/detail-formSys?id=${id}`)
    }

    deleteFormById(idList){
        const query = idList.map(id => `id=${id}`).join('&');
        return http.delete(`/master/system-config/delete-formSys?${query}`);
    }
}

export default new FormSystemService()